// extracted by mini-css-extract-plugin
export default {"player":"VimeoPlayer_player__j9Eac"};